// File: src/utils/exportUtils.js

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { formatDateTime } from './formatting';

export function exportToCSV(filename, headers, rows) {
  const csvContent = [
    headers.join(','),
    ...rows.map(row => headers.map(h => JSON.stringify(row[h] || '')).join(','))
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function exportToPDF(title, headers, rows) {
  const doc = new jsPDF();
  doc.text(title, 14, 20);
  doc.autoTable({ head: [headers], body: rows.map(r => headers.map(h => r[h] || '')) });
  doc.save(`${title.toLowerCase().replace(/\s+/g, '_')}.pdf`);
}